import { APP_INITIALIZER, ErrorHandler, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { JWT_OPTIONS, JwtHelperService, JwtModule  } from '@auth0/angular-jwt';
import { PeAuthService } from './core/services/auth.service';
import { AuthModule } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { SharedModule } from './modules/shared/shared.module';
import { HttpInterceptorService } from './modules/myPrimeRx/services/http-interceptor.service';
import { GlobalErrorsHandlerComponent } from './modules/myPrimeRx/services/global-error-handler';
import { UserLoginComponent } from './modules/myPrimeRx/components/user-login/user-login.component';
import { NgbModule, NgbDatepickerModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap'; 
import { DatadogService } from './services/DatadogService';
import { TimeoutWarningComponent } from './modules/myPrimeRx/components/timeout-warning/timeout-warning.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardModule } from './modules/myPrimeRx/components/dashboard/dashboard.module';

export function initializeDatadog(datadogService: DatadogService): () => void {
  return () => datadogService.init();
}

@NgModule({
  declarations: [
    AppComponent,
    UserLoginComponent,
    TimeoutWarningComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    NgbModule,
    NgbDatepickerModule,
    DashboardModule,
    NgbTypeaheadModule,
    AuthModule.forRoot({
      domain: environment.domain,
      clientId: environment.clientId,
      authorizationParams: {
          redirect_uri: environment.authorizationParams.redirect_uri,
          audience: environment.authorizationParams.audience,
           scope: 'openid profile email offline_access'
      },
       authorizeTimeoutInSeconds: 10,
       useRefreshTokens: true,
       cacheLocation: 'localstorage'
    }),
     BrowserAnimationsModule,
    MatSnackBarModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    PeAuthService, 
    JwtHelperService,
    {
      provide: Window,
      useValue: window,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    { 
      provide: ErrorHandler, 
      useClass: GlobalErrorsHandlerComponent
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeDatadog,
      deps: [DatadogService],
      multi: true,
    },
    HttpInterceptorService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
